// extracted by mini-css-extract-plugin
export default {"flex":"CompB_flex__+5wbL","bonus":"CompB_bonus__mPdU8","month":"CompB_month__iNBAh"};